module.exports = __webpack_public_path__ + "assets/img/101807.5b81a6f7.png";